export const ListBoxTestIdFactory = {
    getListBoxBase: () => 'listbox',
    getListBoxOptionBase: () => [ListBoxTestIdFactory.getListBoxBase(), 'option'].join('-'),
    getListBoxContainerTestId: (testId) => [ListBoxTestIdFactory.getListBoxBase(), 'container', testId].join('-'),
    getListBoxTestId: (testId) => [ListBoxTestIdFactory.getListBoxBase(), testId].join('-'),
    getListBoxOptionTestId: (testId, optionId) => [ListBoxTestIdFactory.getListBoxOptionBase(), testId, optionId].join('-'),
    getListBoxOtherFieldTestId: (testId) => [ListBoxTestIdFactory.getListBoxBase(), 'other-field', testId].join('-'),
    getListBoxLabelTestId: (testId) => [ListBoxTestIdFactory.getListBoxBase(), 'label', testId].join('-'),
    getListBoxDescriptionTestId: (testId) => [ListBoxTestIdFactory.getListBoxBase(), 'description', testId].join('-'),
};
